(ns kyber.styles.animations)

(defn animation-styles
  [_]
  {"@keyframes spin" {"0%" {:transform "rotate(0deg)"}
                      "100%" {:transform "rotate(360deg)"}}
   "@keyframes fill" {"from" {:width "0%"}
                      "to" {:width "100%"}}})
